const WifiIcon = ({ width = 20 }) => (
  <svg width={width} height={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 12.5C10 4.16626 20 4.16626 27.5 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 17.5C12 12.5 18 12.5 22.5 17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 23.75C15.6904 23.75 16.25 23.1904 16.25 22.5C16.25 21.8096 15.6904 21.25 15 21.25C14.3096 21.25 13.75 21.8096 13.75 22.5C13.75 23.1904 14.3096 23.75 15 23.75Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default WifiIcon;